import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SharedService} from "@shared/shared.service";
import {UserInfoModel} from "@services/back-office/model/userInfoModel";

@Component({
    selector: 'app-user-info-component',
    templateUrl: './user-info-component.component.html',
    styleUrls: ['./user-info-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserInfoComponentComponent {
  @Input() searchResult: UserInfoModel;
  constructor(private sharedService: SharedService) { }

  openCrmItem(type: string, id: string) {
    this.sharedService.openCrmItem(type, id);
  }

}
